import { TimeSelection } from './time-selection/time-selection';

export const timeSelectionAlwaysInclude = new TimeSelection({ includeByDefault: true, items: [] });
